import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuthStore } from './auth';

function GoogleAuthCallback() {
  const [status, setStatus] = useState('Processing Google authentication...');
  const navigate = useNavigate();
  const setGoogleTokens = useAuthStore(state => state.setGoogleTokens);
  
  const API_BASE_URL = process.env.REACT_APP_AUTH_BASE_URL || 'https://backend.iceking.wtf';
  
  useEffect(() => {
    const handleCallback = async () => {
      try {
        // Extract code from URL
        const urlParams = new URLSearchParams(window.location.search);
        const code = urlParams.get('code');
        const error = urlParams.get('error');
        
        if (error) {
          throw new Error(`Authentication failed: ${error}`);
        }
        
        if (!code) {
          throw new Error('No authorization code received');
        }
        
        setStatus('Exchanging code for tokens...');
        
        // Exchange code for tokens using your backend API
        const response = await fetch(`${API_BASE_URL}/auth/google/exchange-token`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ code }),
        });
        
        const data = await response.json();
        
        if (!response.ok) {
          throw new Error(data.error || 'Failed to exchange code for tokens');
        }
        
        // Save tokens in store
        setGoogleTokens(
          data.access_token,
          data.refresh_token,
          data.expiry_date || (Date.now() + 3600000)
        );
        
        setStatus('Authentication successful!');
        
        // Redirect back to the original page
        const returnPath = '/';
        // Wait a moment to show success message
        setTimeout(() => {
          navigate(returnPath, { replace: true });
        }, 1000);
      } catch (error) {
        console.error('Authentication error:', error);
        setStatus(`Authentication failed: ${error.message}`);
        
        // Redirect to login after showing error
        setTimeout(() => {
          navigate('/login', { replace: true });
        }, 3000);
      }
    };
    
    handleCallback();
  }, []);
  
  return (
    <div className="flex justify-center items-center h-screen">
      <p>Completing authentication, please wait...</p>
    </div>
  );
}

export default GoogleAuthCallback;